import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M5.256 16.508c.988-.231 2.02-.354 3.083-.354 2.06 0 4.008.461 5.749 1.285a1.923 1.923 0 1 0 1.644-3.477 17.25 17.25 0 0 0-7.393-1.654c-1.36 0-2.686.157-3.96.455a1.923 1.923 0 0 0 .877 3.745ZM8.339 10a19.68 19.68 0 0 0-4.517.522A1.923 1.923 0 1 1 2.94 6.78a23.522 23.522 0 0 1 5.4-.625c3.81 0 7.414.91 10.6 2.526a1.923 1.923 0 0 1-1.74 3.43A19.525 19.525 0 0 0 8.34 10ZM2.367 4.541a25.847 25.847 0 0 1 5.972-.695c4.356 0 8.453 1.08 12.046 2.983a1.923 1.923 0 0 0 1.8-3.399A29.494 29.494 0 0 0 8.34 0C5.98 0 3.683.276 1.48.799a1.923 1.923 0 1 0 .888 3.742Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }